import { Asterisk } from "lucide-react";

const WORDS = ["Raw cold pressed", "Zero added sugar", "Farm to bottle in 12 hours", "Watermelon", "Pineapple", "Apple", "sweetjuice.com"];

export const Marquee = () => (
  <div data-testid="brand-marquee" className="relative bg-[#181203] text-[#FFD000] -rotate-1 scale-[1.02] py-5 overflow-hidden">
    <div className="marquee-track flex w-max">
      {[0, 1].map((k) => (
        <div key={k} className="flex shrink-0" aria-hidden={k === 1}>
          {WORDS.map((w) => (
            <span key={w + k} className="flex items-center gap-6 pr-6 font-display text-2xl md:text-4xl font-bold uppercase tracking-tight whitespace-nowrap">
              {w}
              <Asterisk className="w-7 h-7 text-[#E6194B]" />
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);
